import React, { useState, useEffect } from "react";
// import GUIset_TextArea from "./gui/GUIset_TextArea";
import GUIset_nInput1TextArea from "./gui/GUIset_nInput1TextArea";
// import Template from "./TheTemplate";
import T from "./TheTool";
import Timer from "./TheTimer";


const parseGraph = graphString => {
	const lines = graphString.split('\n');
	const graph = {};
  
	lines.forEach(line => {
	  const [from, to, weight] = line.split(',');
	  if (!graph[from]) {
		graph[from] = {};
	  }
	  if (!graph[to]) {
		graph[to] = {};
	  }
	  graph[from][to] = parseInt(weight);
	  graph[to][from] = parseInt(weight); // For an undirected graph
	});
  
	return graph;
  };

  
const dijkstra = (graph, start, end) => {
	const distances = {};
	const previousNodes = {};
	const priorityQueue = [];
  
	distances[start] = 0;
  
	for (let node in graph) {
	  if (node !== start) {
		distances[node] = Infinity;
	  }
	  priorityQueue.push(node);
	}
  
	while (priorityQueue.length) {
	  priorityQueue.sort((a, b) => distances[a] - distances[b]);
	  const smallest = priorityQueue.shift();
  
	  if (smallest === end) {
		const path = [];
		let current = end;
		while (current !== start) {
		  path.unshift(current);
		  current = previousNodes[current];
		}
		path.unshift(start);
  
		// Calculate and return the distance
		const distance = distances[end];
		return { path, distance };
	  }
  
	  if (distances[smallest] === Infinity) {
		break;
	  }
  
	  for (let neighbor in graph[smallest]) {
		const distance = distances[smallest] + graph[smallest][neighbor];
		if (distance < distances[neighbor]) {
		  distances[neighbor] = distance;
		  previousNodes[neighbor] = smallest;
		}
	  }
	}
  
	return null; // No path found
  };



const ShortestPath = () => {
	useEffect(() => {
		document.title = "Dijkstra's Shortest Path Algorithm";
	}, []);

	const [guiTxtArea, guiTxtAreaChange] = useState(
		// "A,B,1\nA,C,4\nB,C,2\nB,D,5\nC,D,1"
		"A,B,7\nA,C,9\nB,C,10\nB,D,15\nC,D,11\nD,E,6\nA,F,14\nC,F,2\nE,F,9\n"
	);



	const [inputFields, setInputFields] = useState([
		{ label: "Start Node", text: "A" },
		{ label: "End Node", text: "E" },
	]);
	
	// var startNode = "A";
	// var endNode = "D";
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	var txt_input = "";
	var txt_result = "";
	var txt_time = "";

	
	const handleButtonClick = (inputs) => {
		// console.log("TEST"); 
		if (guiTxtArea != "") {
			if (inputs[0] == "" || inputs[1] == "") return;
			// // txt_result = inputs[0] + " to " + inputs[1];
			// // setStartNode(inputs[0]);
			// // setEndNode(inputs[1]);
			// startNode = inputs[0];
			// endNode = inputs[1];
			// // console.log("GO2 " + startNode  + ">>" + endNode); 
			// console.log("GO " + inputs[0]  + ">>" + inputs[1]); 
			// // console.log("GOx " + inputFields[0].text  + ">>" + inputFields[1].text); 
			//---------------------
			process(inputs);
			BuildResult();
		}
	}

	function process(inputs) {
		txt_input = "";
		txt_result = "";
		//
		Timer.start();
		//------------------------------
		// handleFindShortestPath();
		//
		var startNode = inputs[0];
		var endNode = inputs[1];

		// console.log("GO2 " + startNode  + ">>" + endNode); 
		console.log("GO " + inputs[0]  + ">>" + inputs[1]); 
		// console.log("GOx " + inputFields[0].text  + ">>" + inputFields[1].text); 

		const graphString = guiTxtArea;
		const graph = parseGraph(graphString);
		const result = dijkstra(graph, startNode, endNode);

		var output_path = [];
		var output_istance = null;

		if (result) {
			output_path = result.path;
			output_istance = result.distance;
		  } 

		txt_result += "Shortest Path: " + output_path.join(' > ') + "\n";
		txt_result += "Shortest Distance: " + output_istance + "\n";

		//------------------------------
		txt_time = Timer.stop_print();
	}

	
    // const [startNode, setStartNode] = useState('');
    // const [endNode, setEndNode] = useState('');

	// const [path, setPath] = useState([]);
	// const [distance, setDistance] = useState(null);
  
    // const handleFindShortestPath = () => {
	// 	// console.log("GOx " + inputFields[0]  + ">>" + inputFields[1]); 
	// 	const graphString = guiTxtArea;
	// 	const graph = parseGraph(graphString);
	// 	// const result = dijkstra(graph, 'A', 'D');
	// 	const result = dijkstra(graph, startNode, endNode);

	// 	if (result) {
	// 		setPath(result.path);
	// 		setDistance(result.distance);
	// 	  } else {
	// 		setPath([]);
	// 		setDistance(null);
	// 	  }
	// 	// console.log("000" + graphString); 
	// 	// console.log("AAA" + path); 
	// 	// console.log("BBB" + distance); 
	// 	// console.log("CCC" + path.join(' -> ') ); 
    // };

	// //-----------------------------------------------------------
	function BuildResult() {
		partResultChange(
			<div>
				<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
					<h2>Result</h2>
				</div>
				<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>{txt_time}</div>
				<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt_result}</div>
			</div>
		);
		// var part1 = Template.simple01("key1","Input",txt_input,22,22);
		// var part2 = Template.simple3size("key2","Result",txt_time,txt_result,26,20,22);
		// partResultChange(<div>{part1}{part2}</div>);
	}

	//--------------------------------------------------------

	// );

	return (
		<GUIset_nInput1TextArea
		title = "Dijkstra's Shortest Path Algorithm"
		guiTxtArea = {guiTxtArea}
		guiTxtAreaChange={guiTxtAreaChange}
		// buttonClick={buttonClick1}
		partResult={partResult}
		textarea_label1="Graph"
		textarea_label2="each line: node1,node2,distance"
		textarea_placeholder1=""
		//--------------
		desc_v2={
			<div>
				An algorithm for finding the shortest paths between nodes in a weighted graph, which may represent, for example, road networks..
			</div>
		}
		inputFields={inputFields}
		handleButtonClick={handleButtonClick}
		style={1}
		n = {2}
		width1={220}
		but_marginLeft={200}
		//-----------
		txtButton={"Find Route"}
	/>
	);

};

export default ShortestPath;
